// @flow strict

import React, { type Node } from 'react';

import NodeIcon from '@material-ui/icons/InfoOutlined';

import * as styles from './note.module.less';

/**
 * Note component for markdown blog posts.
 * Renders given children within a styled box, including
 * a note icon.
 *
 * @param props - component props
 *
 * @returns {Node}
 */
export const Note = ({ children }): Node => {
  let content = children;

  // content is wrapped markdown
  if (Array.isArray(children) && children.length === 1) {
    const [markdown] = children;
    if (React.isValidElement(markdown)) {
      content = markdown.props.children;
    }
  }

  return (
    <div className={styles.note}>
      <NodeIcon className={styles.noteIcon} />
      <span>{content}</span>
    </div>
  );
};
